import {
  Contact,
  Globe,
  Link2,
  Linkedin,
} from 'lucide-react';
import {
  SiBluesky,
  SiDevdotto,
  SiDiscord,
  SiGithub,
  SiInstagram,
  SiMedium,
  SiSpotify,
  SiThreads,
  SiTiktok,
  SiTwitch,
  SiX,
  SiYoutube,
} from '@icons-pack/react-simple-icons';
import type { LinkKind } from '../types';
import type { ComponentType, SVGProps } from 'react';

export type IconComponent = ComponentType<SVGProps<SVGSVGElement> & { size?: number | string }>;

/**
 * Map for custom link icons: `icon` is a Lucide icon name supplied by the
 * page editor (pascal-cased — e.g. `Music`, `Spotify`). We keep this list
 * small and static to avoid pulling the entire Lucide bundle dynamically.
 */
const CUSTOM_ICONS: Record<string, IconComponent> = {
  Globe,
  Link2,
  Github: SiGithub,
  Linkedin,
  Twitter: SiX,
  Youtube: SiYoutube,
  Instagram: SiInstagram,
};

/**
 * Resolve the icon for a Links Page link. Used by both the public
 * `/p/:slug` render and the editor's live preview so the two stay in sync.
 */
export function iconForLink(kind: LinkKind, customIcon?: string): IconComponent {
  switch (kind) {
    case 'x':
      return SiX;
    case 'linkedin':
      return Linkedin;
    case 'youtube':
      return SiYoutube;
    case 'github':
      return SiGithub;
    case 'instagram':
      return SiInstagram;
    case 'bluesky':
      return SiBluesky;
    case 'threads':
      return SiThreads;
    case 'devto':
      return SiDevdotto;
    case 'medium':
      return SiMedium;
    case 'twitch':
      return SiTwitch;
    case 'tiktok':
      return SiTiktok;
    case 'spotify':
      return SiSpotify;
    case 'discord':
      return SiDiscord;
    case 'website':
      return Globe;
    case 'blog':
      return Globe;
    case 'vcard':
      return Contact;
    case 'custom':
    default:
      if (customIcon && CUSTOM_ICONS[customIcon]) return CUSTOM_ICONS[customIcon];
      return Link2;
  }
}
